// import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Container, Row, Col, Card, Button, Pagination, Spinner } from "react-bootstrap";
// import { motion } from "framer-motion";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Api from "../Utills/Api";
// import logo from "../../Frozenwala.png";
// import Navber from "./Navbar.jsx";
// import Footer from "./Footer.jsx";
// import axios from "axios";
// import { FaSearch } from "react-icons/fa";

// function SearchResults({ refreshCart }) {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { query = "" } = location.state || {};

//   const uid = localStorage.getItem("user_id");
//   const [results, setResults] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [pageSize] = useState(16);
//   const [loading, setLoading] = useState(false);
//   const [tooltipData, setTooltipData] = useState(null);
//   const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
//   const [searchQuery, setSearchQuery] = useState(query);
//   const [isSearching, setIsSearching] = useState(false);
//   const titleRefs = useRef({});

//   // --- STICKY SEARCH BAR ---
//   // Tracks whether the original search bar has been scrolled out of view.
//   // Once it has, we render a fixed, glassy copy pinned to the top instead
//   // of letting it disappear when the user scrolls.
//   const [isSearchSticky, setIsSearchSticky] = useState(false);
//   const searchTriggerRef = useRef(null);
//   const scrollTimeoutRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (scrollTimeoutRef.current) return;

//       scrollTimeoutRef.current = setTimeout(() => {
//         if (searchTriggerRef.current) {
//           const rect = searchTriggerRef.current.getBoundingClientRect();
//           const isSticky = rect.bottom < 0;
//           setIsSearchSticky(isSticky);
//         }
//         scrollTimeoutRef.current = null;
//       }, 100);
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       if (scrollTimeoutRef.current) {
//         clearTimeout(scrollTimeoutRef.current);
//       }
//     };
//   }, []);
//   // --- END STICKY SEARCH BAR ---

//   // ✅ Fetch products with pagination
//   const fetchSearchResults = async (pageNum = 1, searchTerm = query) => {
//     if (!searchTerm) return;
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         `https://backend.frozenwala.com/api/product/search/?q=${searchTerm}&page=${pageNum}&page_size=${pageSize}`
//       );
//       setResults(response.data.results || []);
//       setTotal(response.data.total || 0);
//       setPage(pageNum);
//     } catch (error) {
//       console.error("Error fetching paginated results:", error);
//       toast.error("Failed to load search results!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Handle new search
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchQuery.trim()) {
//       toast.warning("Please enter a search term!");
//       return;
//     }
//     setIsSearching(true);
//     try {
//       await fetchSearchResults(1, searchQuery);
//       // Update URL without reload
//       navigate(`/search`, {
//         state: { query: searchQuery, results: results },
//         replace: true
//       });
//     } catch (error) {
//       console.error("Search error:", error);
//       toast.error("No Result Found!");
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   // ✅ Fetch stock info
//   const getStock = async () => {
//     try {
//       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const map = {};
//       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
//       setStock(map);
//     } catch (error) {
//       console.error("Error getting stock:", error);
//     }
//   };

//   // ✅ Fetch existing cart items
//   const getCartItems = async () => {
//     if (!uid) return;
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       const map = {};
//       response.data.forEach((item) => (map[item.product_id] = item.quantity));
//       setCartItems(map);
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   useEffect(() => {
//     getStock();
//     getCartItems();
//     fetchSearchResults(1, query);
//   }, [query]);

//   // ✅ Add product to cart
//   const onPressAddToCart = async (productId) => {
//     const available = stock[productId];
//     if (available === 0) {
//       toast.warning("No stock available!");
//       return;
//     }

//     if (uid) {
//       try {
//         await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//         refRestCart();
//         setCartItems((prev) => ({
//           ...prev,
//           [productId]: (prev[productId] || 0) + 1,
//         }));
//       } catch (error) {
//         console.error("Error adding product:", error);
//         toast.error("Failed to add item to cart!");
//       }
//     } else {
//       navigate("/login");
//     }
//   };

//   // ✅ Increase quantity
//   const addOne = async (productId) => {
//     const available = stock[productId];
//     if (available === 0) {
//       toast.warning("No stock available!");
//       return;
//     }

//     const currentQty = cartItems[productId] || 0;
//     if (available > currentQty) {
//       await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//       refRestCart();
//     } else {
//       toast.info(`Only ${available} items available in stock.`);
//     }
//   };

//   // ✅ Decrease quantity
//   const subOne = async (productId) => {
//     if (cartItems[productId] > 1) {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: prev[productId] - 1,
//       }));
//       refRestCart();
//     }
//   };

//   // ✅ Pagination Controls
//   const totalPages = Math.ceil(total / pageSize);
//   const handlePageChange = (newPage) => {
//     if (newPage < 1 || newPage > totalPages) return;
//     fetchSearchResults(newPage, query);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const [refresh, setRefresh] = useState(false);
//   const refRestCart = () => setRefresh(prev => !prev);

//   // ✅ Tooltip handlers
//   const handleTooltipEnter = (e, item) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const tooltipWidth = Math.min(320, window.innerWidth - 40);
//     let x = rect.left + rect.width / 2 - tooltipWidth / 2;
//     let y = rect.top - 60;

//     if (x < 10) x = 10;
//     if (x + tooltipWidth > window.innerWidth - 10) {
//       x = window.innerWidth - tooltipWidth - 10;
//     }
//     if (y < 10) y = rect.bottom + 10;

//     setTooltipPosition({ x, y });
//     setTooltipData(item);
//   };

//   const handleTooltipLeave = () => {
//     setTooltipData(null);
//   };

//   // Reusable search bar markup so the inline and sticky versions stay in sync
//   const renderSearchForm = () => (
//     <form onSubmit={handleSearch}>
//       <div className="search-input-group">
//         <span className="search-icon">
//           <FaSearch size={18} />
//         </span>
//         <input
//           type="text"
//           placeholder="Search for products..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//           autoFocus
//         />
//         <button
//           type="submit"
//           className="search-btn"
//           disabled={isSearching}
//         >
//           {isSearching ? "Searching..." : "Search"}
//         </button>
//       </div>
//     </form>
//   );

//   return (
//     <>
//       <style>{`
//         /* Modern Tooltip Styles */
//         .product-title-wrapper {
//           position: relative;
//           display: inline-block;
//           width: 100%;
//         }

//         .product-title-trigger {
//           display: block;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           white-space: nowrap;
//           cursor: pointer;
//           position: relative;
//           font-weight: 600;
//           font-size: 15px;
//           color: #1a202c;
//           margin-bottom: 4px;
//         }

//         .modern-tooltip {
//           position: fixed;
//           background: #1a202c;
//           color: #ffffff;
//           padding: 10px 16px;
//           border-radius: 10px;
//           font-size: 13px;
//           font-weight: 500;
//           max-width: 320px;
//           width: auto;
//           z-index: 9999;
//           pointer-events: none;
//           opacity: 0;
//           transform: translateY(6px) scale(0.96);
//           transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
//                       transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
//           word-break: break-word;
//           line-height: 1.4;
//           border: 1px solid rgba(255, 255, 255, 0.08);
//         }

//         .modern-tooltip.visible {
//           opacity: 1;
//           transform: translateY(0) scale(1);
//         }

//         .modern-tooltip::after {
//           content: '';
//           position: absolute;
//           bottom: -7px;
//           left: 50%;
//           transform: translateX(-50%);
//           border-left: 7px solid transparent;
//           border-right: 7px solid transparent;
//           border-top: 7px solid #1a202c;
//         }

//         .modern-tooltip.bottom::after {
//           top: -7px;
//           bottom: auto;
//           border-bottom: 7px solid #1a202c;
//           border-top: none;
//         }

//         .modern-tooltip .tooltip-accent {
//           display: inline-block;
//           width: 3px;
//           height: 20px;
//           background: #5dc5fa;
//           border-radius: 3px;
//           margin-right: 10px;
//           vertical-align: middle;
//           flex-shrink: 0;
//         }

//         .modern-tooltip .tooltip-content {
//           display: inline-block;
//           vertical-align: middle;
//         }

//         .modern-tooltip .tooltip-title {
//           font-weight: 600;
//           color: #fff;
//           font-size: 13px;
//         }

//         .modern-tooltip .tooltip-sub {
//           font-size: 11px;
//           color: rgba(255, 255, 255, 0.6);
//           margin-top: 1px;
//         }

//         /* Search Bar Styles */
//         .search-bar-container {
//           background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
//           border-radius: 16px;
//           padding: 20px 24px;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
//           margin-bottom: 30px;
//           border: 1px solid rgba(0, 0, 0, 0.04);
//         }

//         .search-input-group {
//           display: flex;
//           align-items: center;
//           background: white;
//           border-radius: 50px;
//           padding: 4px;
//           box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
//           border: 2px solid transparent;
//           transition: all 0.3s ease;
//         }

//         .search-input-group:focus-within {
//           border-color: #5dc5fa;
//           box-shadow: 0 4px 20px rgba(241, 114, 40, 0.15);
//         }

//         .search-input-group .search-icon {
//           padding: 0 12px 0 18px;
//           color: #999;
//         }

//         .search-input-group input {
//           flex: 1;
//           border: none;
//           padding: 12px 0;
//           font-size: 15px;
//           outline: none;
//           background: transparent;
//           color: #333;
//         }

//         .search-input-group input::placeholder {
//           color: #aaa;
//         }

//         .search-input-group .search-btn {
//           background: #5dc5fa;
//           color: white;
//           border: none;
//           padding: 10px 28px;
//           border-radius: 50px;
//           font-weight: 600;
//           font-size: 14px;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           white-space: nowrap;
//         }

//         .search-input-group .search-btn:hover {
//           background: #5dc5fa;
//           transform: scale(1.02);
//           box-shadow: 0 4px 15px rgba(241, 114, 40, 0.3);
//         }

//         .search-input-group .search-btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//           transform: none;
//         }

//         /* Sticky search bar - pinned copy shown once the inline bar scrolls out of view */
//         .sticky-search-bar {
//           position: fixed;
//           top: 111px;
//           left: 0;
//           right: 0;
//           z-index: 999;
//           padding: 12px 24px;
//           background: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(10px);
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
//           border-bottom: 1px solid rgba(0, 0, 0, 0.05);
//           animation: slideDown 0.35s ease forwards;
//         }

//         .sticky-search-bar .search-bar-container {
//           max-width: 600px;
//           margin: 0 auto;
//           box-shadow: none;
//           border: none;
//           background: transparent;
//           padding: 0;
//         }

//         @keyframes slideDown {
//           0% {
//             opacity: 0;
//             transform: translateY(-15px);
//           }
//           100% {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         /* Push content down when the sticky bar takes over, so nothing jumps */
//         .has-sticky-search {
//           padding-top: 76px;
//         }

//         @media (max-width: 576px) {
//           .modern-tooltip {
//             max-width: 260px;
//             padding: 8px 14px;
//             font-size: 12px;
//           }
//           .search-bar-container {
//             padding: 16px;
//           }
//           .search-input-group input {
//             font-size: 14px;
//             padding: 10px 0;
//           }
//           .search-input-group .search-btn {
//             padding: 8px 16px;
//             font-size: 13px;
//           }
//           .sticky-search-bar {
//             top: 56px;
//             padding: 10px 16px;
//           }
//         }
//       `}</style>

//       <Navber refreshCart={refresh} />

//       {/* Sticky search bar - only rendered once the inline one is scrolled past */}
//       {isSearchSticky && (
//         <div className="sticky-search-bar">
//           <div className="search-bar-container">
//             {renderSearchForm()}
//           </div>
//         </div>
//       )}

//       {/* Tooltip Element */}
//       {tooltipData && (
//         <div
//           className={`modern-tooltip visible ${tooltipPosition.y < 100 ? 'bottom' : ''}`}
//           style={{
//             left: tooltipPosition.x,
//             top: tooltipPosition.y,
//           }}
//         >
//           <div style={{ display: 'flex', alignItems: 'flex-start' }}>
//             <span className="tooltip-accent"></span>
//             <div className="tooltip-content">
//               <div className="tooltip-title">{tooltipData.title}</div>
//               {tooltipData.brand_name && (
//                 <div className="tooltip-sub">Brand: {tooltipData.brand_name}</div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       <Container className={`mt-5 pt-5 ${isSearchSticky ? "has-sticky-search" : ""}`}>
//         {/* Modern Search Bar (inline, tracked for scroll position) */}
//         <div className="search-bar-container" ref={searchTriggerRef}>
//           {renderSearchForm()}
//         </div>

//         <h4 className="mb-4 text-center">
//           Search Results for <span className="text-warning">"{query}"</span>
//           {total > 0 && (
//             <span className="text-muted" style={{ fontSize: '16px', fontWeight: 'normal' }}>
//               {" "}({total} products)
//             </span>
//           )}
//         </h4>

//         {loading ? (
//           <div className="text-center my-5">
//             <Spinner animation="border" variant="warning" />
//           </div>
//         ) : results.length === 0 ? (
//           <div className="text-center py-5">
//             <img
//               src="/img/gallery/no-products.svg"
//               alt="No results"
//               style={{ width: "150px", marginBottom: "20px", opacity: 0.6 }}
//               onError={(e) => e.target.style.display = "none"}
//             />
//             <p className="text-muted">No products found for "{query}"</p>
//             <p className="text-muted small">Try searching with different keywords</p>
//           </div>
//         ) : (
//           <>
//             <Row>
//               {results.map((item) => {
//                 const isSoldOut = item.stock === 0;
//                 return (
//                   <Col key={item.id} sm={6} md={4} lg={3} className="mb-4">
//                     <motion.div
//                       whileHover={{ scale: 1.03 }}
//                       transition={{ type: "spring", stiffness: 120 }}
//                       className="card border-0 rounded-4 h-100 position-relative"
//                     >
//                       {isSoldOut && (
//                         <div
//                           className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 text-white d-flex align-items-center justify-content-center fw-bold fs-5"
//                           style={{ borderRadius: "0.5rem" }}
//                         >
//                           Sold Out
//                         </div>
//                       )}

//                       <Card.Img
//                         variant="top"
//                         src={item.item_photo || logo}
//                         onError={(e) => (e.target.src = logo)}
//                         style={{ height: "200px", objectFit: "cover", cursor: "pointer" }}
//                         onClick={() => navigate(`/products/${item.id}`)}
//                       />

//                       <Card.Body className="d-flex flex-column text-center">
//                         {/* Product Title with Modern Tooltip */}
//                         <div className="product-title-wrapper">
//                           <div
//                             className="product-title-trigger"
//                             onMouseEnter={(e) => handleTooltipEnter(e, item)}
//                             onMouseLeave={handleTooltipLeave}
//                           >
//                             {item.title}
//                           </div>
//                         </div>

//                         <Card.Text className="mb-2">
//                           {item.item_old_price && (
//                             <span className="text-muted text-decoration-line-through ms-1">
//                               ₹{item.item_old_price}
//                             </span>
//                           )}
//                           {" "}
//                           <span className="text-success fw-bold">
//                             ₹{item.item_new_price}
//                           </span>
//                           <span className="discount-badge" style={{
//                             backgroundColor: '#5dc5fa',
//                             color: 'white',
//                             padding: '4px 8px',
//                             borderRadius: '12px',
//                             fontSize: '14px',
//                             marginLeft: '10px',
//                             fontWeight: 'bold'
//                           }}>
//                             {item.discount_percentage}% OFF
//                           </span>
//                         </Card.Text>

//                         {/* ✅ Quantity buttons or Add to Cart */}
//                         {cartItems[item.id] && !isSoldOut ? (
//                           <div className="d-flex justify-content-center align-items-center gap-2 mt-auto">
//                             <Button
//                               variant="outline-danger"
//                               size="sm"
//                               onClick={() => subOne(item.id)}
//                               style={{ color: "black" }}
//                             >
//                               −
//                             </Button>
//                             <span className="fw-bold">{cartItems[item.id]}</span>
//                             <Button
//                               variant="outline-success"
//                               size="sm"
//                               onClick={() => addOne(item.id)}
//                               style={{ color: "black" }}
//                             >
//                               +
//                             </Button>
//                           </div>
//                         ) : (
//                           <motion.button
//                             whileHover={{ scale: 1.1 }}
//                             className="btn btn-warning btn-sm rounded-pill mt-auto fw-semibold"
//                             onClick={() => onPressAddToCart(item.id)}
//                             disabled={isSoldOut}
//                             style={{
//                               background: isSoldOut ? '#ccc' : '#5dc5fa',
//                               border: 'none',
//                               color: 'white'
//                             }}
//                           >
//                             {isSoldOut ? "Out of Stock" : "Add to Cart"}
//                           </motion.button>
//                         )}
//                       </Card.Body>
//                     </motion.div>
//                   </Col>
//                 );
//               })}
//             </Row>

//             {/* ✅ Pagination Bar */}
//             {totalPages > 1 && (
//               <div className="d-flex justify-content-center my-4">
//                 <Pagination>
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(page - 1)}
//                     disabled={page === 1}
//                   />
//                   {[...Array(totalPages)].slice(0, 5).map((_, idx) => {
//                     const pageNum = idx + 1;
//                     return (
//                       <Pagination.Item
//                         key={pageNum}
//                         active={page === pageNum}
//                         onClick={() => handlePageChange(pageNum)}
//                       >
//                         {pageNum}
//                       </Pagination.Item>
//                     );
//                   })}
//                   {totalPages > 5 && <Pagination.Ellipsis disabled />}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(page + 1)}
//                     disabled={page === totalPages}
//                   />
//                 </Pagination>
//               </div>
//             )}
//           </>
//         )}

//         <ToastContainer />
//       </Container>
//       <Footer />
//     </>
//   );
// }

// export default SearchResults;

import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Pagination, Spinner } from "react-bootstrap";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Api from "../Utills/Api";
import logo from "../../Frozenwala.png";
import Navber from "./Navbar.jsx";
import Footer from "./Footer.jsx";
import axios from "axios";
import { FaSearch } from "react-icons/fa";
import ProductModal from "./ProductModal"; // Add this import

function SearchResults({ refreshCart }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { query = "" } = location.state || {};

  const uid = localStorage.getItem("user_id");
  const [results, setResults] = useState([]);
  const [cartItems, setCartItems] = useState({});
  const [stock, setStock] = useState({});
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(16);
  const [loading, setLoading] = useState(false);
  const [tooltipData, setTooltipData] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [searchQuery, setSearchQuery] = useState(query);
  const [isSearching, setIsSearching] = useState(false);
  const titleRefs = useRef({});

  // Modal states - Add these
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // --- STICKY SEARCH BAR ---
  // Tracks whether the original search bar has been scrolled out of view.
  // Once it has, we render a fixed, glassy copy pinned to the top instead
  // of letting it disappear when the user scrolls.
  const [isSearchSticky, setIsSearchSticky] = useState(false);
  const searchTriggerRef = useRef(null);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollTimeoutRef.current) return;

      scrollTimeoutRef.current = setTimeout(() => {
        if (searchTriggerRef.current) {
          const rect = searchTriggerRef.current.getBoundingClientRect();
          const isSticky = rect.bottom < 0;
          setIsSearchSticky(isSticky);
        }
        scrollTimeoutRef.current = null;
      }, 100);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);
  // --- END STICKY SEARCH BAR ---

  // Add modal handlers
  const handleProductClick = (productId) => {
    setSelectedProductId(productId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProductId(null);
  };

  // ✅ Fetch products with pagination
  const fetchSearchResults = async (pageNum = 1, searchTerm = query) => {
    if (!searchTerm) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `https://backend.frozenwala.com/api/product/search/?q=${searchTerm}&page=${pageNum}&page_size=${pageSize}`
      );
      setResults(response.data.results || []);
      setTotal(response.data.total || 0);
      setPage(pageNum);
    } catch (error) {
      console.error("Error fetching paginated results:", error);
      toast.error("Failed to load search results!");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Handle new search
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) {
      toast.warning("Please enter a search term!");
      return;
    }
    setIsSearching(true);
    try {
      await fetchSearchResults(1, searchQuery);
      // Update URL without reload
      navigate(`/search`, {
        state: { query: searchQuery, results: results },
        replace: true
      });
    } catch (error) {
      console.error("Search error:", error);
      toast.error("No Result Found!");
    } finally {
      setIsSearching(false);
    }
  };

  // ✅ Fetch stock info
  const getStock = async () => {
    try {
      const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
      const map = {};
      response.data.forEach((item) => (map[item.item_id] = item.openingstock));
      setStock(map);
    } catch (error) {
      console.error("Error getting stock:", error);
    }
  };

  // ✅ Fetch existing cart items
  const getCartItems = async () => {
    if (!uid) return;
    try {
      const response = await Api.get(`api/get_cart/?user_id=${uid}`);
      const map = {};
      response.data.forEach((item) => (map[item.product_id] = item.quantity));
      setCartItems(map);
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  useEffect(() => {
    getStock();
    getCartItems();
    fetchSearchResults(1, query);
  }, [query]);

  // ✅ Add product to cart
  const onPressAddToCart = async (productId) => {
    const available = stock[productId];
    if (available === 0) {
      toast.warning("No stock available!");
      return;
    }

    if (uid) {
      try {
        await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
        refRestCart();
        setCartItems((prev) => ({
          ...prev,
          [productId]: (prev[productId] || 0) + 1,
        }));
      } catch (error) {
        console.error("Error adding product:", error);
        toast.error("Failed to add item to cart!");
      }
    } else {
      navigate("/login");
    }
  };

  // ✅ Increase quantity
  const addOne = async (productId) => {
    const available = stock[productId];
    if (available === 0) {
      toast.warning("No stock available!");
      return;
    }

    const currentQty = cartItems[productId] || 0;
    if (available > currentQty) {
      await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
      setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
      refRestCart();
    } else {
      toast.info(`Only ${available} items available in stock.`);
    }
  };

  // ✅ Decrease quantity
  const subOne = async (productId) => {
    if (cartItems[productId] > 1) {
      await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
      setCartItems((prev) => ({
        ...prev,
        [productId]: prev[productId] - 1,
      }));
      refRestCart();
    }
  };

  // ✅ Pagination Controls
  const totalPages = Math.ceil(total / pageSize);
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    fetchSearchResults(newPage, query);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [refresh, setRefresh] = useState(false);
  const refRestCart = () => setRefresh(prev => !prev);

  // ✅ Tooltip handlers
  const handleTooltipEnter = (e, item) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const tooltipWidth = Math.min(320, window.innerWidth - 40);
    let x = rect.left + rect.width / 2 - tooltipWidth / 2;
    let y = rect.top - 60;

    if (x < 10) x = 10;
    if (x + tooltipWidth > window.innerWidth - 10) {
      x = window.innerWidth - tooltipWidth - 10;
    }
    if (y < 10) y = rect.bottom + 10;

    setTooltipPosition({ x, y });
    setTooltipData(item);
  };

  const handleTooltipLeave = () => {
    setTooltipData(null);
  };

  // Reusable search bar markup so the inline and sticky versions stay in sync
  const renderSearchForm = () => (
    <form onSubmit={handleSearch}>
      <div className="search-input-group">
        <span className="search-icon">
          <FaSearch size={18} />
        </span>
        <input
          type="text"
          placeholder="Search for products..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          autoFocus
        />
        <button
          type="submit"
          className="search-btn"
          disabled={isSearching}
        >
          {isSearching ? "Searching..." : "Search"}
        </button>
      </div>
    </form>
  );

  return (
    <>
      <style>{`
        /* Modern Tooltip Styles */
        .product-title-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        }

        .product-title-trigger {
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          position: relative;
          font-weight: 600;
          font-size: 15px;
          color: #1a202c;
          margin-bottom: 4px;
        }

        .modern-tooltip {
          position: fixed;
          background: #1a202c;
          color: #ffffff;
          padding: 10px 16px;
          border-radius: 10px;
          font-size: 13px;
          font-weight: 500;
          max-width: 320px;
          width: auto;
          z-index: 9999;
          pointer-events: none;
          opacity: 0;
          transform: translateY(6px) scale(0.96);
          transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                      transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
          word-break: break-word;
          line-height: 1.4;
          border: 1px solid rgba(255, 255, 255, 0.08);
        }

        .modern-tooltip.visible {
          opacity: 1;
          transform: translateY(0) scale(1);
        }

        .modern-tooltip::after {
          content: '';
          position: absolute;
          bottom: -7px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 7px solid #1a202c;
        }

        .modern-tooltip.bottom::after {
          top: -7px;
          bottom: auto;
          border-bottom: 7px solid #1a202c;
          border-top: none;
        }

        .modern-tooltip .tooltip-accent {
          display: inline-block;
          width: 3px;
          height: 20px;
          background: #5dc5fa;
          border-radius: 3px;
          margin-right: 10px;
          vertical-align: middle;
          flex-shrink: 0;
        }

        .modern-tooltip .tooltip-content {
          display: inline-block;
          vertical-align: middle;
        }

        .modern-tooltip .tooltip-title {
          font-weight: 600;
          color: #fff;
          font-size: 13px;
        }

        .modern-tooltip .tooltip-sub {
          font-size: 11px;
          color: rgba(255, 255, 255, 0.6);
          margin-top: 1px;
        }

        /* Search Bar Styles */
        .search-bar-container {
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-radius: 16px;
          padding: 20px 24px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          margin-bottom: 30px;
          border: 1px solid rgba(0, 0, 0, 0.04);
        }

        .search-input-group {
          display: flex;
          align-items: center;
          background: white;
          border-radius: 50px;
          padding: 4px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
          border: 2px solid transparent;
          transition: all 0.3s ease;
        }

        .search-input-group:focus-within {
          border-color: #5dc5fa;
          box-shadow: 0 4px 20px rgba(241, 114, 40, 0.15);
        }

        .search-input-group .search-icon {
          padding: 0 12px 0 18px;
          color: #999;
        }

        .search-input-group input {
          flex: 1;
          border: none;
          padding: 12px 0;
          font-size: 15px;
          outline: none;
          background: transparent;
          color: #333;
        }

        .search-input-group input::placeholder {
          color: #aaa;
        }

        .search-input-group .search-btn {
          background: #5dc5fa;
          color: white;
          border: none;
          padding: 10px 28px;
          border-radius: 50px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s ease;
          white-space: nowrap;
        }

        .search-input-group .search-btn:hover {
          background: #5dc5fa;
          transform: scale(1.02);
          box-shadow: 0 4px 15px rgba(241, 114, 40, 0.3);
        }

        .search-input-group .search-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        /* Sticky search bar - pinned copy shown once the inline bar scrolls out of view */
        .sticky-search-bar {
          position: fixed;
          top: 111px;
          left: 0;
          right: 0;
          z-index: 999;
          padding: 12px 24px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          animation: slideDown 0.35s ease forwards;
        }

        .sticky-search-bar .search-bar-container {
          max-width: 600px;
          margin: 0 auto;
          box-shadow: none;
          border: none;
          background: transparent;
          padding: 0;
        }

        @keyframes slideDown {
          0% {
            opacity: 0;
            transform: translateY(-15px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Push content down when the sticky bar takes over, so nothing jumps */
        .has-sticky-search {
          padding-top: 76px;
        }

        @media (max-width: 576px) {
          .modern-tooltip {
            max-width: 260px;
            padding: 8px 14px;
            font-size: 12px;
          }
          .search-bar-container {
            padding: 16px;
          }
          .search-input-group input {
            font-size: 14px;
            padding: 10px 0;
          }
          .search-input-group .search-btn {
            padding: 8px 16px;
            font-size: 13px;
          }
          .sticky-search-bar {
            top: 56px;
            padding: 10px 16px;
          }
        }
      `}</style>

      <Navber refreshCart={refresh} />

      {/* Product Modal */}
      <ProductModal
        isOpen={isModalOpen}
        productId={selectedProductId}
        onClose={handleCloseModal}
        refreshCart={refreshCart}
      />

      {/* Sticky search bar - only rendered once the inline one is scrolled past */}
      {isSearchSticky && (
        <div className="sticky-search-bar">
          <div className="search-bar-container">
            {renderSearchForm()}
          </div>
        </div>
      )}

      {/* Tooltip Element */}
      {tooltipData && (
        <div
          className={`modern-tooltip visible ${tooltipPosition.y < 100 ? 'bottom' : ''}`}
          style={{
            left: tooltipPosition.x,
            top: tooltipPosition.y,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span className="tooltip-accent"></span>
            <div className="tooltip-content">
              <div className="tooltip-title">{tooltipData.title}</div>
              {tooltipData.brand_name && (
                <div className="tooltip-sub">Brand: {tooltipData.brand_name}</div>
              )}
            </div>
          </div>
        </div>
      )}

      <Container className={`mt-5 pt-5 ${isSearchSticky ? "has-sticky-search" : ""}`}>
        {/* Modern Search Bar (inline, tracked for scroll position) */}
        <div className="search-bar-container" ref={searchTriggerRef}>
          {renderSearchForm()}
        </div>

        <h4 className="mb-4 text-center">
          Search Results for <span className="text-warning">"{query}"</span>
          {total > 0 && (
            <span className="text-muted" style={{ fontSize: '16px', fontWeight: 'normal' }}>
              {" "}({total} products)
            </span>
          )}
        </h4>

        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" variant="warning" />
          </div>
        ) : results.length === 0 ? (
          <div className="text-center py-5">
            <img
              src="/img/gallery/no-products.svg"
              alt="No results"
              style={{ width: "150px", marginBottom: "20px", opacity: 0.6 }}
              onError={(e) => e.target.style.display = "none"}
            />
            <p className="text-muted">No products found for "{query}"</p>
            <p className="text-muted small">Try searching with different keywords</p>
          </div>
        ) : (
          <>
            <Row>
              {results.map((item) => {
                const isSoldOut = item.stock === 0;
                return (
                  <Col key={item.id} sm={6} md={4} lg={3} className="mb-4">
                    <motion.div
                      whileHover={{ scale: 1.03 }}
                      transition={{ type: "spring", stiffness: 120 }}
                      className="card border-0 rounded-4 h-100 position-relative"
                    >
                      {isSoldOut && (
                        <div
                          className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 text-white d-flex align-items-center justify-content-center fw-bold fs-5"
                          style={{ borderRadius: "0.5rem" }}
                        >
                          Sold Out
                        </div>
                      )}

                      <Card.Img
                        variant="top"
                        src={item.item_photo || logo}
                        onError={(e) => (e.target.src = logo)}
                        style={{ height: "200px", objectFit: "cover", cursor: "pointer" }}
                        // Replace navigation with modal handler
                        onClick={() => handleProductClick(item.id)}
                      />

                      <Card.Body className="d-flex flex-column text-center">
                        {/* Product Title with Modern Tooltip */}
                        <div className="product-title-wrapper">
                          <div
                            className="product-title-trigger"
                            onMouseEnter={(e) => handleTooltipEnter(e, item)}
                            onMouseLeave={handleTooltipLeave}
                            // Add click handler to title
                            onClick={() => handleProductClick(item.id)}
                          >
                            {item.title}
                          </div>
                        </div>

                        <Card.Text className="mb-2">
                          {item.item_old_price && (
                            <span className="text-muted text-decoration-line-through ms-1">
                              ₹{item.item_old_price}
                            </span>
                          )}
                          {" "}
                          <span className="text-success fw-bold">
                            ₹{item.item_new_price}
                          </span>
                          <span className="discount-badge" style={{
                            backgroundColor: '#5dc5fa',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '12px',
                            fontSize: '14px',
                            marginLeft: '10px',
                            fontWeight: 'bold'
                          }}>
                            {item.discount_percentage}% OFF
                          </span>
                        </Card.Text>

                        {/* ✅ Quantity buttons or Add to Cart */}
                        {cartItems[item.id] && !isSoldOut ? (
                          <div className="d-flex justify-content-center align-items-center gap-2 mt-auto">
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => subOne(item.id)}
                              style={{ color: "black" }}
                            >
                              −
                            </Button>
                            <span className="fw-bold">{cartItems[item.id]}</span>
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={() => addOne(item.id)}
                              style={{ color: "black" }}
                            >
                              +
                            </Button>
                          </div>
                        ) : (
                          <motion.button
                            whileHover={{ scale: 1.1 }}
                            className="btn btn-warning btn-sm rounded-pill mt-auto fw-semibold"
                            onClick={() => onPressAddToCart(item.id)}
                            disabled={isSoldOut}
                            style={{
                              background: isSoldOut ? '#ccc' : '#5dc5fa',
                              border: 'none',
                              color: 'white'
                            }}
                          >
                            {isSoldOut ? "Out of Stock" : "Add to Cart"}
                          </motion.button>
                        )}
                      </Card.Body>
                    </motion.div>
                  </Col>
                );
              })}
            </Row>

            {/* ✅ Pagination Bar */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center my-4">
                <Pagination>
                  <Pagination.Prev
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  />
                  {[...Array(totalPages)].slice(0, 5).map((_, idx) => {
                    const pageNum = idx + 1;
                    return (
                      <Pagination.Item
                        key={pageNum}
                        active={page === pageNum}
                        onClick={() => handlePageChange(pageNum)}
                      >
                        {pageNum}
                      </Pagination.Item>
                    );
                  })}
                  {totalPages > 5 && <Pagination.Ellipsis disabled />}
                  <Pagination.Next
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  />
                </Pagination>
              </div>
            )}
          </>
        )}

        <ToastContainer />
      </Container>
      <Footer />
    </>
  );
}

export default SearchResults;